import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';

export const loadPaymentMethods = createAction(containerConstants.LOAD_PAYMENT_METHODS);

export const loadPaymentMethodsSuccess = createAction(
  containerConstants.LOAD_PAYMENT_METHODS_SUCCESS,
  (methods: any[]) => ({ payload: { methods } })
);

export const loadPaymentMethodsError = createAction(
  containerConstants.LOAD_PAYMENT_METHODS_ERROR,
  (error: string) => ({ payload: { error } })
);

export const savePaymentMethodRequest = createAction(
  'settings/SAVE_PAYMENT_METHOD_REQUEST',
  (name: string, type?: string) => ({ payload: { name, type } })
);

export const removePaymentMethodRequest = createAction(
  'settings/REMOVE_PAYMENT_METHOD_REQUEST',
  (id: string) => ({ payload: { id } })
);
